import "./payment-modal.scss";
import { html, nothing } from "lit";
import * as bootstrap from "bootstrap";
import ComponentModal, { modalStates } from "./component-modal";
import { FormatPrice } from "../assets/js/libs/utils";
import ConfirmationDialog from "./confirmation-dialog";
import "./component-amount-selector";
import { Receipts } from "../assets/js/libs/api";

class PaymentModal extends ComponentModal {
  static get tagName() {
    return "payment-modal";
  }

  constructor(resolve, reject, amount) {
    super(resolve, reject);
    this.modalTitle = "Attesa pagamento...";
    this.submitBtnText = "Pagato";
    this.fullScreen = true;
    this.amount = amount;
    this.receivedAmount = 0.0;
    this.addList = [];
    this.denominations = [
      { code: "one-cen", label: "1€cent", value: 0.01, type: "coin" },
      { code: "two-cen", label: "2€cent", value: 0.02, type: "coin" },
      { code: "fiv-cen", label: "5€cent", value: 0.05, type: "coin" },
      { code: "ten-cen", label: "10€cent", value: 0.1, type: "coin" },
      { code: "twe-cen", label: "20€cent", value: 0.2, type: "coin" },
      { code: "fif-cen", label: "50€cent", value: 0.5, type: "coin" },
      { code: "one-eur", label: "1€", value: 1.0, type: "coin" },
      { code: "two-eur", label: "2€", value: 2.0, type: "coin" },
      { code: "fiv-eur", label: "5€", value: 5.0, type: "banknote" },
      { code: "ten-eur", label: "10€", value: 10.0, type: "banknote" },
      { code: "twe-eur", label: "20€", value: 20.0, type: "banknote" },
      { code: "fif-eur", label: "50€", value: 50.0, type: "banknote" },
      { code: "onh-eur", label: "100€", value: 100.0, type: "banknote" },
      { code: "twh-eur", label: "200€", value: 200.0, type: "banknote" },
      // { code: "fih-eur", label: "500€", value: 500.00, type: "banknote" }
    ];
  }

  OnDenomClick(denom) {
    this.receivedAmount = parseFloat(this.receivedAmount) + denom.value;
    this.addList.push(denom.value);
    this.requestUpdate();
  }

  async Reprint(iD) {
    try {
      await ConfirmationDialog.Show({
        heading: "Ristampa",
        message: "Vuoi ristampare lo scontrino?",
      });
      try {
        await Receipts.Print(iD);
      } catch (error) {
        console.error(error);
        ComponentAlert.Show({ msg: "Errore. Riprova." });
      }
    } catch (error) {
      console.error(error);
    }
  }

  get modalBody() {
    return html`
      <div class="d-flex justify-content-around">
        <div class="left">
          <div class="buttons-wrap">
            <div class="denoms coins">
              ${this.denominations
                .filter((denoms) => denoms.type == "coin")
                .reverse()
                .map(
                  (denom) => html`
                    <div
                      class="denom"
                      data-count=${this.addList.filter(
                        (add) => add == denom.value
                      ).length || nothing}
                      data-type=${denom.type}
                      data-label=${denom.label}
                      data-code=${denom.code}
                      @click=${() => this.OnDenomClick(denom)}
                    ></div>
                  `
                )}
            </div>
            <div class="denoms banknotes">
              ${this.denominations
                .filter((denoms) => denoms.type == "banknote")
                .map(
                  (denom) => html`
                    <div
                      class="denom"
                      data-count=${this.addList.filter(
                        (add) => add == denom.value
                      ).length || nothing}
                      data-type=${denom.type}
                      data-label=${denom.label}
                      data-code=${denom.code}
                      @click=${() => this.OnDenomClick(denom)}
                    ></div>
                  `
                )}
            </div>
          </div>
          <div class="right-buttons">
            <div>
              <button
                type="button"
                class="btn btn-light"
                @click=${() => this.Undo()}
              >
                Cancella ultimo
              </button>
            </div>
            <div>
              <button
                type="button"
                class="btn btn-light"
                @click=${() => this.Undo(true)}
              >
                Cancella tutto
              </button>
            </div>
          </div>
        </div>
        <div>
          <component-amount-selector
            @amountChange=${this.OnManualAmount}
          ></component-amount-selector>
        </div>
      </div>
      <div class="amounts">
        <div class="total-row">
          <span class="label">Inserito:</span>
          <span class="value"
            >${FormatPrice().format(this.receivedAmount.toFixed(2))}</span
          >
        </div>
        <div class="total-row">
          <span class="label">Totale:</span>
          <span class="value"
            >${FormatPrice().format(this.amount.toFixed(2))}</span
          >
        </div>
        <div class="change-row">
          <span class="label">Resto:</span>
          <span class="value"
            >${FormatPrice().format(
              this.receivedAmount - this.amount.toFixed(2)
            )}</span
          >
        </div>
      </div>
    `;
  }

  OnManualAmount(e) {
    this.addList.length = 0;
    this.receivedAmount = e.detail.amount;
    if (this.receivedAmount == 0) this.classList.remove("manual-input");
    else this.classList.add("manual-input");
    this.requestUpdate();
  }

  Undo(reset = false) {
    if (this.addList.length == 0) return;

    if (reset) {
      this.receivedAmount = 0;
      this.requestUpdate();
      this.addList.length = 0;
      return;
    }

    this.receivedAmount =
      parseFloat(this.receivedAmount) - this.addList[this.addList.length - 1];
    this.requestUpdate();
    this.addList.pop();
  }

  OnSubmit() {
    this.modalStatus = modalStates.SUBMITTED;
    this.Hide();
  }
}
PaymentModal.Register();
export default PaymentModal;
